<template>
  <div class="container overflow-hidden justify-content-center " id="container">
      <slot/>
  </div>
</template>

<script>
export default {
  name: "last_Loading",
}
</script>

<style scoped>

</style>